import { Piece, PieceAction, PieceEvent, PieceState } from '@apiContract';
import orderBy from 'lodash/orderBy';

import { filterSystemPieceEvents } from '@utils/piece';
import { useMe } from './useMe';

// TODO: Refactor and probably remove this hook.

export const getPieceStorageType = (storageType: 1 | 2 | 'mail' | 'packages') => {
  const storageTypeId = typeof storageType === 'number' ? storageType : storageType === 'mail' ? 1 : 2;
  const storageTypeName = typeof storageType === 'string' ? storageType : storageType === 1 ? 'mail' : 'packages';

  return {
    id: storageTypeId,
    name: storageTypeName,
  };
};

export const useMailpiece = () => {
  const { currentUser } = useMe();

  const getPieceUsersForCurrentUser = (piece: Piece) => {
    return piece.users.filter((user) => user.userId === currentUser?.id);
  };

  const getLastPieceAction = (events: PieceEvent[]) => events[events.length - 1].action;
  const getPenultimateAction = (events: PieceEvent[]) => events[events.length - 2].action;

  const getMailroomPieceState = (piece: Piece) => {
    const usersForAuthUser = getPieceUsersForCurrentUser(piece);
    const mailroomAccessUser = usersForAuthUser.find((user) => user.access === 'Mailroom');

    return mailroomAccessUser?.pieceState || null;
  };

  const getRecipientPieceState = (piece: Piece) => {
    const usersForAuthUser = getPieceUsersForCurrentUser(piece);
    const recipientAccessUser = usersForAuthUser.find(
      (user) => user.access === 'Recipient' || user.access === 'OldRecipient',
    );

    return recipientAccessUser?.pieceState || null;
  };

  const archiveConditionRecipient = (piece: Piece) => {
    return PieceState.Archived === getRecipientPieceState(piece);
  };

  const getPreArchivedAction = (piece: Piece) => {
    const events = filterSystemPieceEvents(orderBy(piece.events, 'created'));
    const penultimateAction = getPenultimateAction(events);
    const lastAction = getLastPieceAction(events);
    if (penultimateAction === PieceAction.Submit || penultimateAction === PieceAction.FinishOpenAndScan) {
      return lastAction;
    }
    return penultimateAction;
  };

  const getForceActionTitle = (pieces: Piece[]): string => {
    const isAnyForce = pieces.some((p) => getMailroomPieceState(p) !== PieceState.ActionRequested);
    return isAnyForce ? 'Force Request' : 'Change Request';
  };

  return { getMailroomPieceState, getPreArchivedAction, archiveConditionRecipient, getForceActionTitle };
};
